import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './common.css'
import { shareImages } from '../../redux/album'
import { fetchUsers } from '../../redux/users'
import Modal from '../modals/Modal'
import LoadingSpinner from '../LoadingSpinner'
import ErrorMessage from '../ErrorMessage'
import Icon from '../Icon'
import ShareButton from '../ShareButton'
import ConfirmButtons from '../ConfirmButtons'

class ImageShare extends Component {
  state = {
    checked: [],
    success: false,
    submitting: false
  }
  componentDidMount () {
    const { users, fetchUsers } = this.props
    if (!users) {
      fetchUsers()
    }
  }
  onSubmit = () => {
    const { images, users, shareImages } = this.props
    const { checked } = this.state
    const promises = []
    this.setState({ submitting: true })
    users.forEach(user => {
      if (checked.indexOf(user.id) !== -1) {
        promises.push(shareImages(images, user.id))
      }
    })
    Promise.all(promises).then(() => {
      this.setState({
        success: true,
        submitting: false
      })
    })
  }
  renderUser = user => {
    const { checked } = this.state
    const isChecked = checked.indexOf(user.id) !== -1
    const onCheck = () => this.setState({ checked: checked.concat(user.id), success: false })
    const onUncheck = () => this.setState({ checked: checked.filter(id => id !== user.id), success: false })
    return (
      <li key={user.id}>
        <button
          className={isChecked ? classNames.userChecked : classNames.user}
          onClick={isChecked ? onUncheck : onCheck}>
          <div style={{ flex: 1 }}>
            <div className={classNames.userName}>
              {user.name}
            </div>
            <div className={classNames.userEmail}>
              {user.email}
            </div>
          </div>
          <div className={isChecked ? classNames.checkboxChecked : classNames.checkbox}>
            {isChecked &&
              <Icon icon='tick' className={classNames.tick} size={16} />
            }
          </div>
        </button>
      </li>
    )
  }
  render () {
    const { users, fetching, error, fetchUsers, onCancel } = this.props

    if (!users || fetching) {
      return <LoadingSpinner />
    }

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching all users'
          onRetry={fetchUsers}
        />
      )
    }

    const { images, canShareInternal, canShareExternal, externalPath } = this.props
    const { success, submitting } = this.state

    return (
      <Modal title={images.length === 1 ? 'Share image' : 'Share images'} onClose={onCancel}>
        <div className={classNames.page}>
          {canShareExternal &&
            <ShareButton
              images={images}
              path={externalPath}
            />
          }
          {canShareInternal &&
            <div>
              <div className={classNames.heading}>
                Within Blayzr
              </div>
              <ul>
                {users.map(this.renderUser)}
              </ul>
              {success &&
                <p className={classNames.note}>Images were successfully shared</p>
              }
              <ConfirmButtons
                onConfirm={this.onSubmit}
                onCancel={onCancel}
                confirmText='Share'
                confirmDisabledText='Sharing…'
                confirmDisabled={submitting}
              />
            </div>
          }
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ({ users, entities, auth }, props) => {
  return {
    users: users.data && users.data
      .filter(id => id !== auth.user.id)
      .map(id => entities.users[id]),
    fetching: users.fetching,
    error: users.error
  }
}

const mapDispatchToProps = {
  fetchUsers,
  shareImages
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageShare)



// WEBPACK FOOTER //
// ./src/components/album/ImageShare.js